import { useState, useEffect, Fragment } from 'react';
import { Header, User, Icon, Card, useTranslation } from 'components/lib';
import Style from './appPlain.module.scss';

export function AppPlainLayout({ mobile = false, ...props }) {

  // context & style
  // const context = useContext(AuthContext);
  const [isMobile, setIsMobile] = useState(!mobile ? window.innerWidth <= 640 : false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 640);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const { t } = useTranslation();


  return (
    <Fragment>
      {(isMobile) ?
        <><div className={Style.warnContainer}>
          <Card tittle="Oops! Your screen size is too small for this website." center shadow className={Style.warnCard}>
            <Icon
              className={Style.icon}
              size={30}
              color={'orange'}
              image={'alert-triangle'}
            />
            <p>Your screen size is too small for this website.</p>
          </Card>
        </div>
        </>
        : <></>}
      <div style={{ display: isMobile ? 'none' : '' }}>
        <main className={Style.appPlain} style={{ marginTop: "2em" }}>
          <Header showNav={props?.navBar} title={t(props.title) || props.title}>
            <User />
          </Header>

          {<props.children {...props.data} t={t}/>}

        </main>
      </div>
    </Fragment>
  );
}